/* eslint-disable no-undef */
import $ from "jquery";
window.$ = window.jQuery = $;
import "bootstrap/dist/js/bootstrap";
import "./slick";

(function ($) {
	//  Code here

	// move order detail to side
	var orderDetail = $("#order_review");
	var aditionalOrder = $(".woocommerce-additional-fields__field-wrapper");
	aditionalOrder.append(orderDetail);

	// change search text to search icon
	$(".woocommerce-product-search button").html('<span class="icon"><i class="fa fa-search"></i></span>');

	// move banner slider dot
	// $("ul.slick-dots").insertAfter($(".icons"));

	function wpslStyling() {
		// remove wpsl search above the search result
		$("#wpsl-stores").prepend($(".wpsl-search"));

		// change search button text to icon
		// eslint-disable-next-line no-unused-vars
		var icon = "<i class='fa fa-search'></i>";
		$(".wpsl-search-btn-wrap input").addClass("fas fa-map-marker-alt");
	}

	wpslStyling();
})(jQuery);
